<template>
  <div
    class="lego-text-field lego-input"
    :class="textfieldClass"
    :style="textfieldStyle"
    v-bind="attrsWithoutEvent"
  >
    <div v-show="guide && isShowGuildMessage" ref="guildeWrap" class="guild-message-wrap">
      <span class="guild-message-wrap__text"> {{ guide }} </span>
    </div>

    <textarea
      v-if="textarea"
      v-bind="listenersWithoutInput"
      ref="input"
      v-model="txtFieldModel"
      class="lego-text-field__textarea"
      :rows="$_rows"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :onfocus="readonly && 'this.blur();'"
      :style="{ resize: resize, height: customHeightTextField }"
      :tabindex="tabindex"
      :maxlength="counter"
      @keyup.enter.prevent.stop="enterHandler"
      @blur="onBlur"
      @focus="onFocus"
      @input="onInput"
      @click="onFocus"
    ></textarea>
    <input
      v-else
      v-bind="listenersWithoutInput"
      ref="input"
      v-model="txtFieldModel"
      v-lego-tooltip:ellipsis="txtFieldModel"
      :type="inputType"
      step=""
      :class="inputClass"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :onfocus="readonly && 'this.blur();'"
      :tabindex="tabindex"
      :maxlength="counter"
      @keyup.enter.prevent.stop="enterHandler"
      @blur="onBlur"
      @focus="onFocus"
      @input="onInput"
      @click="onFocus"
    />
    <div
      class="lego-text-field__icon-wrap"
      :class="{
        'event-set': (clearable && txtFieldModel) || (searchable && txtFieldModel) || withIcon
      }"
      v-show="!disabled"
    >
      <div class="clear-btn" v-show="(clearable && txtFieldModel) || (searchable && txtFieldModel)">
        <lego-icon
          class="lego-text-field__icon-wrap__icon"
          iconType="df"
          icon="delete"
          :size="16"
          @mousedown="mouseDownClearable"
        />
      </div>
      <div v-show="withIcon">
        <lego-icon
          class="lego-text-field__icon-wrap__icon"
          :size="16"
          iconType="df"
          @click="toggleIcon"
          >{{ icon }}
        </lego-icon>
      </div>
    </div>
    <div
      v-if="errorMsg || messageShow || counter"
      class="lego-text-field__message"
      :class="messageClass"
    >
      <span class="lego-validator__message" v-lego-tooltip:ellipsis="messageShow + errorMsg">
        {{ messageShow }}{{ errorMsg }}</span
      >
      <div v-if="counter && showCounter" class="lego-text-field__counter">
        {{ typeof txtFieldModel === 'string' ? txtFieldModel.length.toLocaleString() : 0 }}/
        {{ Number(counter).toLocaleString() }}
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  emits: ['update:modelValue', 'enter', 'setMetricItems', 'click-icon', 'blur', 'clear'],
  props: {
    typeInput: {
      type: String,
      default: 'text'
    },
    modelValue: [String, Number, Array],
    width: {
      type: [Number, String],
      default: null
    },
    isCounter: {
      type: Boolean,
      default: true
    },
    messageStyle: {
      type: String,
      validator: function (value) {
        return ['heavy', 'light', 'light-one-line', 'heavy-one-line'].indexOf(value) !== -1;
      },
      default: 'light'
    },
    errorMsg: { type: String, default: '' },
    isKeyHandler: {
      type: Boolean,
      default: true
    },
    isHideSpecialCharacter: {
      type: Boolean,
      default: false
    },
    mutateInput: {
      type: Function,
      default: null
    },
    disableInputMutation: {
      type: Boolean,
      default: false
    },
    isEventMessage: {
      type: Boolean,
      default: false
    },
    guide: {
      type: String,
      default: ''
    },
    showCounter: {
      type: Boolean,
      default: false
    },
    isFreeText: {
      type: Boolean,
      default: true
    },
    customHeightTextField: {
      type: String
    },
    maxContentGuide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputType() {
      if ((this.password || this.pw) && !this.visible) {
        return 'password';
      }
      return this.typeInput;
    },
    textfieldClass() {
      let clazz = [];
      clazz.push('lego-text-field--' + this.$_size);
      clazz.push('lego-text-field--' + this.$_style);

      if (this.errorMessage) {
        clazz.push('lego-text-field--has-message');
      }
      if (this.hasError === true || this.errorMsg) {
        clazz.push('lego-validator--error');
      }
      if (this.showValid && this.hasError === false) {
        clazz.push('lego-validator--valid');
      }
      if (this.shake) {
        clazz.push('lego-validator--shake');
      }
      if (this.isCounter) {
        clazz.push('lego-is-conter');
      }
      return clazz;
    },
    textfieldStyle() {
      return { width: this.width && `${this.getNumber(this.width)}px` };
    },
    withIcon() {
      if (this.textarea) {
        return false;
      }
      if (this.password || this.pw) {
        return true;
      }
      if (this.searchable) {
        return true;
      }
      return false;
    },
    icon() {
      if (this.password || this.pw) {
        return this.visible ? 'hide' : 'show';
      }
      if (this.searchable) {
        return 'search';
      }
      return '';
    },
    inputClass() {
      return {
        'lego-text-field__input': true,
        'lego-text-field__input--with-icon': this.withIcon && this.searchable,
        'lego-text-field__input--with-icon-one':
          (this.withIcon && !this.searchable) || (this.clearable && this.txtFieldModel),
        'lego-text-filed__input--only-eng': this.withPwd
      };
    },
    listenersWithoutInput() {
      // TODO - Remove if not needed.
      const attrs = this.$attrs;
      const listeners = {};
      for (const key in attrs) {
        if (typeof attrs[key] === 'function') {
          listeners[key] = attrs[key];
        }
      }
      // TODO - Remove if not needed.
      return Object.assign({}, listeners, {
        input: function (event) {}
      });
    },
    onScrolling() {
      return this.$store.state.commonStore.scroll;
    }
  },
  watch: {
    txtFieldModel(newText, oldText) {
      this.cursorPosition = this.$refs?.input && this.$refs.input.selectionStart;
      if (newText === oldText) return;
      if (!newText.trim()) {
        this.$emit('update:modelValue', '');
        return;
      }

      if (this.mask == null) {
        this.realText = newText;
        // $ver: v0.1.0
        // $arg: updated value
        // 입력 값이 변경될 때, 변경된 값을 파라미터로 이벤트를 발생시킵니다.
        // #When the input value is changed, an event is triggered with the changed value as a parameter.
        this.$emit('update:modelValue', newText);

        return;
      } else {
        if (this.mask === 'phone') {
          newText = this.onlyNums(newText);
          if (newText.length < 11) {
            this.predefinedMasks['phone'] = '### - ### - ####';
          } else {
            this.predefinedMasks['phone'] = '### - #### - ####';
          }
        } else if (this.mask === 'currency') {
          let newMask = '';
          newText = this.onlyNums(newText);
          newText = parseInt(newText) + '';

          for (let i = 1; i <= (newText.length > 14 ? 14 : newText.length); i++) {
            newMask += '#';
            if ((newText.length - i) % 3 === 0 && i !== newText.length) {
              newMask += ',';
            }
          }
          this.predefinedMasks['currency'] = newMask;
        }
        this.txtFieldModel = this.applyMask(newText, this.mask);
        if (this.txtFieldModel !== this.$refs.input.value) {
          this.$refs.input.value = this.txtFieldModel;
        }
        this.$emit('update:modelValue', String(this.realText));
        return;
      }
    },
    modelValue: {
      immediate: true,
      handler(val, oldVal) {
        if (this.mask === 'phone') {
          if (val.length < 11) {
            this.predefinedMasks['phone'] = '### - ### - ####';
          } else {
            this.predefinedMasks['phone'] = '### - #### - ####';
          }
        } else if (this.mask === 'currency') {
          this.predefinedMasks['currency'] = '########################################';
        }
        if (this.mask) {
          this.txtFieldModel = this.applyMask(val, this.mask);
        } else {
          if (val && val.length >= this.counter && !this.guide) {
            this.blur();
            this.txtFieldModel = val.slice(0, this.counter);
            this.$nextTick(() => {
              this.focus();
            });
          } else {
            this.txtFieldModel = val;
          }
        }
      }
    },
    onScrolling() {
      this.onscroll();
    }
  },
  data() {
    return {
      blurFlag: true,
      txtFieldModel: '',
      isShowGuildMessage: false,
      cursorPosition: 0
    };
  },
  methods: {
    toggleIcon() {
      if (this.password) {
        this.visible = !this.visible;
      } else if (this.searchable) {
        // $ver: v0.1.0
        // $arg: value
        // searchable 속성으로 표시된 검색아이콘을 클릭할 때, 현재 값을 파라미터로 이벤트를 발생시킵니다.
        // #When clicking on the search icon marked with the searchable property, an event is triggered with the current value as a parameter.
        this.$emit(
          'click-icon',
          this.textarea ? this.txtFieldModel : this.txtFieldModel.replace(/\s{2,}/gi, ' ').trim()
        );
      }
    },
    getNumber(str) {
      let v = str;
      if (isNaN(v)) {
        v = v.replace(/[^0-9]/g, '');
      }
      return parseInt(v);
    },
    keyHandler(text) {
      if (this.isKeyHandler) {
        return text.replace(this.$const.NOT_ALLOWED_REGEX.COMMON, '');
      }
    },
    mouseDownClearable() {
      this.blurFlag = false;
      this.txtFieldModel = '';
      this.$emit('update:modelValue', '');
      this.$emit('clear');
    },
    onBlur() {
      this.isShowGuildMessage = false;
      if (this.blurFlag) {
        if (!this.textarea) {
          this.txtFieldModel = (this.txtFieldModel || '')
            .replace(this.$const.NOT_ALLOWED_REGEX.SPACE_REPLACE, ' ')
            .trim();
        }
        this.$nextTick(() => {
          this.validateOnEvent();
          this.$emit('blur');
        });
      }
    },
    onFocus(e) {
      this.blurFlag = true;
      this.handleGuideMsg(e);
    },
    onInput(event) {
      let text = this.txtFieldModel;
      const originalLength = text.length;

      if (!this.isEventMessage && !this.isFreeText) {
        text = text.replace(this.$const.NOT_ALLOWED_REGEX.PREVENT_XSS, '');
      }

      if (!this.mask && !this.disableInputMutation) {
        if (this.mutateInput) {
          text = this.mutateInput(text);
        } else if (!this.isFreeText) {
          text = text.replace(this.$const.NOT_ALLOWED_REGEX.COMMON, '');
        }
      }

      if (text.startsWith(' ')) text = text.trimStart();
      text = text.replace(this.$const.NOT_ALLOWED_REGEX.CONSECUTIVE_WHITE_SPACE, ' ');

      const lastLength = text.length;
      this.txtFieldModel = text;
      const position = Math.max(this.cursorPosition - (originalLength - lastLength), 0);
      this.onFocus(event);
      this.$nextTick(() => {
        if (originalLength - lastLength) event.target.setSelectionRange(position, position);
      });
    },
    handleGuideMsg(e) {
      if (!this.guide) return;
      this.isShowGuildMessage = true;
      this.$nextTick(() => {
        // config position tooltip top
        if (!this.$refs.guildeWrap || !this.$refs.input) return;
        const element = this.$refs.input.getBoundingClientRect();
        if (this.maxContentGuide) {
          this.$refs.guildeWrap.style.width = 'max-content';
        } else {
          this.$refs.guildeWrap.style.width = element.width + 'px';
        }
        const elementGuide = this.$refs.guildeWrap.getBoundingClientRect();
        this.$refs.guildeWrap.style.top = element.top - elementGuide.height - 10 + 'px';
        this.$refs.guildeWrap.style.left = element.left + 'px';
      });
    },
    onscroll() {
      this.isShowGuildMessage = false;
    },
    // checkIsShowGuildMessage()
    enterHandler: _.debounce(function () {
      if (!this.textarea) {
        this.txtFieldModel = this.txtFieldModel
          .replace(this.$const.NOT_ALLOWED_REGEX.SPACE_REPLACE, ' ')
          .trim();
      }
      this.$emit('enter', this.txtFieldModel);
    }, 0),
    changeGuideMsg() {
      if (!this.isShowGuildMessage) return;
      this.handleGuideMsg();
    }
  },
  mounted() {
    document.addEventListener('scroll', this.onscroll);
    window.addEventListener('resize', this.changeGuideMsg);
  },
  beforeUnmount() {
    document.removeEventListener('scroll', this.onscroll);
    window.removeEventListener('resize', this.changeGuideMsg);
  }
};
</script>
<style lang="scss" scoped>
$border-color: #adadad;
$border-color--forcus: #2c59d9;
.guild-message-wrap {
  display: flex;
  background: #fff;
  border: 1px solid #e0e1e6;
  gap: 8px;
  padding: 8px;
  box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.15);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;

  &__text {
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    color: #333333;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 7px;
    width: 10px;
    height: 10px;
    box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.15);
    background: #fff;
    transform: rotate(45deg);
  }

  .scp-tooltip:empty {
    padding: 0;
    min-height: 0;
    max-width: 0;
    display: none;
  }
}

.lego-text-field__input,
.lego-text-field__textarea {
  padding: 6px 10px 6px 12px;
  border-radius: 2px;
  border-color: $border-color;

  &:hover {
    border-color: $lego-text-field__border-color--focus;
  }

  &:not(:readonly):not(:focus):not(:disabled):hover {
    border-color: $lego-text-field__border-color--over;
  }

  &[readonly] {
    pointer-events: none;
    background-color: $lego-text-field__background-color--readonly;
    border-color: $lego-text-field__border-color--readonly;
    -ms-user-select: none;
  }

  &:disabled {
    pointer-events: none;
    background-color: $lego-text-field__background-color--disabled;
    border-color: $lego-text-field__border-color--disabled;
    color: $lego-text-field__color--disabled;
  }

  &:focus {
    border-color: $border-color--forcus;

    & + .lego-text-field__icon-wrap {
      .clear-btn {
        display: inline-block;
      }
    }
  }
}

.lego-text-field {
  &:hover {
    .clear-btn {
      display: inline-block;
    }
  }

  &.lego-is-conter {
    .lego-text-field__counter {
      display: block;
    }
  }
}

.lego-text-field__input {
  @include ellipsis;
}

.lego-text-field__textarea {
  &::-webkit-scrollbar {
    width: 14px;
    height: 18px;
  }

  &::-webkit-scrollbar-thumb {
    cursor: default;
    min-height: 50px;
    border-radius: 6px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    background-color: rgba(#1f2533, 0.2);
    -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05),
      inset 1px 1px 0px rgba(0, 0, 0, 0.05);
  }

  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
}

.lego-text-field--small {
  .lego-text-field__input {
    @include font(12px);
  }

  .lego-text-field__icon-wrap {
    height: $lego-text-field__height--small;
  }
}

.lego-text-field--medium {
  .lego-text-field__input {
    @include font(14px);
  }

  .lego-text-field__icon-wrap {
    height: $lego-text-field__height--medium;
  }
}

.lego-text-field--large {
  .lego-text-field__input {
    @include font(14px);
  }

  .lego-text-field__icon-wrap {
    height: $lego-text-field__height--large;
  }
}

.lego-text-field--small .lego-text-field__textarea {
  @include font(12px);
}

.lego-text-field--medium .lego-text-field__textarea {
  @include font(14px);
}

.lego-text-field--large .lego-text-field__textarea {
  @include font(14px);
}

.lego-text-field--small .lego-text-field__icon-wrap {
  @include font(12px);
}

.lego-text-field--medium .lego-text-field__icon-wrap {
  @include font(14px);
}

.lego-text-field--large .lego-text-field__icon-wrap {
  @include font(14px);
}

.lego-text-field__icon-wrap {
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  pointer-events: none;

  &.event-set {
    pointer-events: all;
  }

  > div {
    &.clear-btn {
      display: none;

      :deep .opus-icon__delete {
        position: relative;
        top: 2px;
      }
    }

    + div {
      height: 16px;
      margin-left: 4px;
    }
  }
}

.lego-text-field--small .lego-text-field__input--with-icon {
  padding-right: $lego-text-field__font-size--small + nth($lego-text-field__padding, 2) * 2 + 14;
}

.lego-text-field--medium .lego-text-field__input--with-icon {
  padding-right: $lego-text-field__font-size--medium + nth($lego-text-field__padding, 2) * 2 + 14;
}

.lego-text-field--large .lego-text-field__input--with-icon {
  padding-right: $lego-text-field__font-size--large + nth($lego-text-field__padding, 2) * 2 + 14;
}

.lego-text-field--small .lego-text-field__input--with-icon-one {
  padding-right: $lego-text-field__font-size--small + nth($lego-text-field__padding, 2) * 2 - 6;
}

.lego-text-field--medium .lego-text-field__input--with-icon-one {
  padding-right: $lego-text-field__font-size--medium + nth($lego-text-field__padding, 2) * 2 - 6;
}

.lego-text-field--large .lego-text-field__input--with-icon-one {
  padding-right: $lego-text-field__font-size--large + nth($lego-text-field__padding, 2) * 2 - 6;
}

.lego-text-field {
  .lego-validator__message {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: pre-wrap;
    text-overflow: ellipsis;
  }

  &__message {
    display: flex;
    gap: 8px;
    line-height: 18px;
    color: #adadad;
    position: relative;
    word-break: break-word;
    justify-content: space-between;

    .lego-text-field__counter {
      color: $border-color;
    }
  }

  &__counter {
    white-space: pre;
  }
}

:deep input::placeholder {
  color: #bbbdc1 !important;
}
</style>
